/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TransactionThresholdExpressedAs {
    TOTAL_VALUE_IN_TIER = 'TOTAL_VALUE_IN_TIER',
    VALUE_PER_UNIT = 'VALUE_PER_UNIT',
}
